import { useCallback, useEffect, useState } from "react";
import { api, errText } from "@/lib/api";
import { AddCard } from "./AddCard";
import { ListCard } from "./ListCard";

export default function ManageAccess({ onExpired }) {
  const [data, setData] = useState({ total: 0, items: [] });
  const [q, setQ] = useState("");
  const [err, setErr] = useState("");
  const load = useCallback(async query => {
    const r = await api(`/api/admin/access?q=${encodeURIComponent(query || "")}`);
    if (r.status === 401) { onExpired(); return; }
    const d = await r.json();
    if (!r.ok) { setErr(errText(d)); return; }
    setErr(""); setData(d);
  }, [onExpired]);
  useEffect(() => { const t = setTimeout(() => load(q), 200); return () => clearTimeout(t); }, [q, load]);
  return (
    <div data-testid="admin-access-page">
      {err ? <div className="adm-msg err" role="alert" data-testid="admin-error">{err}</div> : null}
      <div className="grid">
        <AddCard onAdded={() => load(q)} />
        <ListCard data={data} q={q} setQ={setQ} onChanged={() => load(q)} />
      </div>
    </div>
  );
}
